import { gsap, ScrollTrigger } from "../layout";

import Tab from 'bootstrap/js/dist/tab';
import Dropdown from 'bootstrap/js/dist/dropdown';

// matchheight
import {matchHeight, matchHeightPerRow} from '../matchHeight';

function teamCard() {
    const dropdownItems = document.querySelectorAll('.region__dropdown-item');
    const cardInfo = document.querySelectorAll('.team-card__matchheight');
    const cardInfoCol = document.querySelectorAll('.team-card__col');
    const cardItemMobile = document.querySelectorAll('.team-card__item-mobile');
    
    // dropdown menu on mobile
    const regionDropdownToggle = document.querySelector('.region__dropdown-toggle');
    if (window.innerWidth < 1025) {
        dropdownItems.forEach(el => {
            el.addEventListener('click', () => {
                regionDropdownToggle.innerHTML = el.textContent;
            })
        })
    }

    // matchHeight(cardInfo);
    if (window.innerWidth < 1025) {
        matchHeightPerRow(cardInfo);
        matchHeightPerRow(cardInfoCol);
        dropdownItems.forEach(el => {            
            el.addEventListener('click', () => {
                matchHeightPerRow(cardInfo);
                matchHeightPerRow(cardInfoCol);
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    teamCard();
})

window.addEventListener('resize', () => {
    teamCard();
})